import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * The layout for every `/flights/*` route.
 *
 * Only an outlet: the list lives at the index (`flights.index.tsx`) and a
 * single track's map at `flights.$trackId.tsx`. Splitting it this way rather
 * than branching inside one component is what lets the URL, not a prop, say
 * which of the two is on screen.
 */
export const Route = createFileRoute('/flights')({
  component: Outlet,
});
